import React from 'react';
import { Link } from 'react-router-dom';

// Import MUI icons for the builder options
import BuildIcon from '@mui/icons-material/Build';
import ChatIcon from '@mui/icons-material/Chat';
import SettingsIcon from '@mui/icons-material/Settings';
import LockIcon from '@mui/icons-material/Lock';

export default function PlaybookBuilder() {
  return (
    <div className="page-wrapper">
      <div className="page-container">
        <header className="page-header">
          <div className="header-content">
            <h1>Build a playbook</h1>
            <p className="header-subtitle">Choose how you want to create it. The simple builder is the quickest place to start.</p>
          </div>
        </header>

        <div className="builder-options">
          <div className="builder-option active">
            <div className="builder-option-icon">
              <BuildIcon />
            </div>
            <h2>Simple builder</h2>
            <p>Build your playbook by selecting from our pre-built strategies. Perfect for getting started with UFC betting.</p>
            <Link to="/playbooks/build/simple" className="builder-option-button">
              Start the simple builder
            </Link>
          </div>

          <div className="builder-option active">
            <div className="builder-option-icon">
              <ChatIcon />
            </div>
            <h2>Language builder</h2>
            <p>Describe your betting strategy in plain English, and we'll turn it into a working playbook using AI.</p>
            <Link to="/playbooks/build/language" className="builder-option-button">
              Describe a strategy
            </Link>
          </div>

          <div className="builder-option disabled">
            <div className="builder-option-icon">
              <SettingsIcon />
            </div>
            <div className="coming-soon-badge">
              <LockIcon />
              Coming soon
            </div>
            <h2>Advanced builder</h2>
            <p>Build complex, multi-strategy playbooks with custom rules, filters, and allocation methods.</p>
            <button className="builder-option-button" disabled>
              Not available yet
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
